import _isEqual from "lodash/isEqual";
import * as React from 'react';
/**
 * Memoize a result using deep equality. This hook has two advantages over
 * React.useMemo: it uses deep equality to compare memo keys, and it guarantees
 * that the memo function will only be called if the keys are unequal.
 * React.useMemo cannot be relied on to do this, since it is only a performance
 * optimization (see https://reactjs.org/docs/hooks-reference.html#usememo).
 *
 * Copied from https://github.com/apollographql/react-apollo/blob/master/packages/hooks/src/utils/useDeepMemo.ts.
 */
export function useDeepMemo(memoFn, key) {
  var ref = React.useRef();
  if (!ref.current || !_isEqual(key, ref.current.key)) {
    ref.current = {
      key: key,
      value: memoFn()
    };
  }
  return ref.current.value;
}
//# sourceMappingURL=useDeepMemo.js.map
